import React from 'react'
import PropTypes from 'prop-types'
import Head from 'next/head'
import Error from 'next/error'
import axios from 'axios'

import { trackEvent } from '../../utils/analytics'
import getGlobals from '../../utils/getGlobals'

import AktivWidget from '../../components/AktivWidget'

const AktivWidgetPage = React.memo(({ statusCode, code, data, error }) => {
  if (error) {
    if (statusCode === 404) {
      trackEvent('code-not-found', 'error', code)
      return <Error statusCode={404} title="Finner ikke siden du etterspør" />
    }
    return <Error statusCode={statusCode} title={error.statusText} />
  }

  return (
    <>
      <Head>
        <title key="title">{data.address} - Aktiv Eiendomsmegling</title>
      </Head>
      <AktivWidget
        key={data.id}
        address={data.address}
        id={data.id}
        links={data.links}
        location={data.location}
        pois={data.pois}
      />
    </>
  )
})

AktivWidgetPage.getInitialProps = async ({ query }) => {
  let error = null
  let data = null
  let statusCode // no statusCode
  const code = query && query.code ? query.code : ''

  try {
    const res = await axios(`/iframe/getProfile?id=${code}`, {
      baseURL: getGlobals().API_SERVER,
    })
    data = res.data // eslint-disable-line prefer-destructuring
  } catch (err) {
    error = {
      status: err.response ? err.response.status : '',
      statusText: err.response ? err.response.statusText : '',
    }
    statusCode = err.response ? err.response.status : 500
  }

  return { statusCode, code, data, error }
}

AktivWidgetPage.propTypes = {
  statusCode: PropTypes.number,
  code: PropTypes.string.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    address: PropTypes.string,
    links: PropTypes.shape({
      main: PropTypes.string.isRequired,
      map: PropTypes.string.isRequired,
    }),
    location: PropTypes.shape({
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
    }),
    pois: PropTypes.arrayOf(
      PropTypes.shape({
        distanceText: PropTypes.string,
        poiId: PropTypes.string,
        poiType: PropTypes.string,
        poiTypeId: PropTypes.number,
        travelType: PropTypes.string,
      }),
    ).isRequired,
  }),
  error: PropTypes.shape({
    status: PropTypes.number,
    statusText: PropTypes.string,
  }),
}

export default AktivWidgetPage
